

























































































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { ObjectHelper } from '@fruitpackage/helpers';
import StoreDispatcher from '@service/StoreDispatcher';
import { StepMixin, ErrorResponseMixin } from '@mixin';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            prev: {
                to: '/apply/new/applicant/community-toegestaan',
            },
            next: {
                to: '/',
                disabled: true,
            },
            autosave: false,
            post: {
                name: '',
                street: '',
                postal: '',
                city: '',
                email: '',
                website: '',
                iban: '',
                registered: '',
                community: 1,
            },
        };
    },

    created() {
        const user = this.authUser.data;
        this.post.name = this.userCommunityName;
        this.post.street = this.authUser.data.street;
        this.post.postal = this.authUser.data.postal;
        this.post.city = this.authUser.data.city;
        this.post.email = user.email;

        let website = '';
        let iban = '';
        let registered = '';

        Object.keys(this.stateOrganisations).forEach(key => {
            const organisation = this.stateOrganisations[key];
            if (organisation.community) {
                website = organisation.website;
                iban = organisation.iban;
                registered = organisation.registered;
            }
        });

        this.post.website = website;
        this.post.iban = iban;
        this.post.registered = registered;
    },

    mixins: [
        StepMixin,
        ErrorResponseMixin,
    ],

    methods: {
        async onNext() {
            return this.$validator.validate().then(valid => {
                if (!valid) return;

                return StoreDispatcher.createOrganisation(this.post).then(response => {
                    if (response instanceof Error) {
                        this.errorData = this.getErrorMessage(response);
                        return false;
                    }

                    const data = {
                        organisation_id: response.id,
                        community: 1,
                    };
                    return StoreDispatcher.createProject(data).then(response => {
                        if (response instanceof Error) {
                            this.errorData = this.getErrorMessage(response);
                            return false;
                        }

                        return `/apply/${ response.id }/applicant/add-contact-question`;
                    });
                });
            });
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class MaakOrganisatie extends Vue {

}

